import { Grid } from "@mui/material";
import Styles from "./Rules.module.css";
import { PddWiev, ThemeList } from "../../../components/PDD";
import { useEffect, useState } from "react";
import { getThemeList } from "../../../utils/API/biletMethod";
import { usePortal } from "../../../hooks/store";
import { useSearchParams } from "react-router";

export default function Pdd() {
  const LoadingPortal = usePortal();
  const [params, setParams] = useSearchParams();

  const [themeData, setData] = useState([]);

  useEffect(() => {
    LoadingPortal.setPortal();
    getThemeList().then((res) => {
      setData(res.data);
      setParams({ theme: res.data[0].id, name: res.data[0].name });
      LoadingPortal.closePortal();
    });
  }, []);

  return (
    !LoadingPortal.open &&
    !!themeData.length &&
    (window.innerWidth > 768 ? (
      <Grid container spacing={4} sx={{ height: "100%", width: "100%" }}>
        <Grid size={3} className={[Styles.pdd_item, Styles.theme_list]}>
          <ThemeList themeData={themeData} />
        </Grid>
        <Grid
          size={9}
          className={Styles.pdd_item}
          style={{
            height: "100%",
            backgroundColor: "white",
            borderRadius: "0.5rem",
          }}>
          <PddWiev />
        </Grid>
      </Grid>
    ) : (
      <section className={Styles.mobile_pdd_section}>
        <div className={Styles.mobile_theme_list}>
          <ThemeList themeData={themeData} />
        </div>
        <PddWiev />
      </section>
    ))
  );
}
